const DOMAIN = "https://api.prod.logdms.io";
const STORAGE_DOMAIN = "https://storage.prod.logdms.io/";

module.exports = { DOMAIN, STORAGE_DOMAIN };
